import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './UtilityMenu.less'

class UtilityMenu extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    closeOnItemClick: PropTypes.bool
  }

  static defaultProps = {
    closeOnItemClick: true
  }

  state = {
    open: false
  }

  componentDidMount () {
    document.addEventListener('click', this._handleClickOutside)
    document.addEventListener('keydown', this._handleEsc)
  }

  componentWillUnmount () {
    document.removeEventListener('click', this._handleClickOutside)
    document.removeEventListener('keydown', this._handleEsc)
  }

  _handleClickOutside = (e) => {
    if (this.state.open && this.containerRef && !this.containerRef.contains(e.target)) {
      this._close()
    }
  }

  _handleEsc = (e) => {
    if (e.key === 'Escape' && this.state.open) {
      this._close()
    }
  }

  _toggle = (e) => {
    e.stopPropagation()
    this.setState({ open: !this.state.open })
  }

  _close = () => {
    if (this.state.open) {
      this.setState({ open: false })
    }
  }

  _handleMenuClick = (e) => {
    if (this.props.closeOnItemClick && e.target.tagName === 'A') {
      this._close()
    }
  }

  render () {
    const { children, className } = this.props
    const { open } = this.state

    const validChildren = React.Children.toArray(children).filter(Boolean)

    if (validChildren.length === 0) {
      return null
    }

    return (
      <div
        className={classNames('component-utility-menu utility', { open }, className)}
        ref={ref => this.containerRef = ref}
      >
        <a className='dots' onClick={this._toggle} />
        <div onClick={this._handleMenuClick}>
          {children}
        </div>
      </div>
    )
  }
}

export default UtilityMenu
UtilityMenu.displayName = 'UtilityMenu'
